import { render, staticRenderFns } from "./storedecoration.vue?vue&type=template&id=1741edd8&scoped=true"
import script from "./storedecoration.vue?vue&type=script&lang=js"
export * from "./storedecoration.vue?vue&type=script&lang=js"
import style0 from "./storedecoration.vue?vue&type=style&index=0&id=1741edd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1741edd8",
  null
  
)

component.options.__file = "storedecoration.vue"
export default component.exports